module.exports = __webpack_public_path__ + "img/menu-3.58422bdc.svg";